const xhrMemory = Symbol("xhr_memory");

/**
 * Subscreve as requisições feitas pelo fetch e XMLHttpRequest
 */
export function proxyRequest() {
  // Ajuste para ficar compatível com o proxyRequest do yanda
  // TODO: remover o proxyRequest do yanda e remover o if
  if (!globalThis.fetchOriginal) {
    globalThis.fetchOriginal = globalThis.fetch;
  }
  if (!globalThis.XMLHttpRequestOriginal) {
    globalThis.XMLHttpRequestOriginal = XMLHttpRequest;
  }

  installFetchProxy();
  installXMLHttpRequestProxy();
}

function installFetchProxy() {
  globalThis.fetch = function (resource, options) {
    return globalThis.fetchOriginal(resource, addXMLHttpRequestHeader(options))
      .then((resp) => {
        if (resp.ok) {
          return resp;
        }

        if (resp.status == 403 && resp.headers.get("x-auth-requested")) {
          return resp.json().then(({ type, msg, label, uuid }) =>
            new Promise((resolve, reject) => {
              Siggma.controleAcesso({
                type,
                msg,
                label,
                sessionUuid: uuid,
                liberar: ({ sessionUuid }) => {
                  const newOptions = options || {};
                  newOptions.headers = {
                    ...newOptions.headers,
                    ...{ "x-auth-uuid": sessionUuid },
                  };
                  resolve(fetch(resource, newOptions));
                },
                cancel: () => reject("Operação cancelada"),
                // bloquear: () => reject("Operação bloqueada"),
              });
            })
          );
        }

        return resp.text().then((text) => {
          processHttpError(resp.status, text);
          throw Error(
            text ||
              "Erro ao efetuar a comunicação com o servidor<br>Tente novamente",
          );
        });
      });
  };
}

function installXMLHttpRequestProxy() {
  globalThis.XMLHttpRequest = function () {
    const xhr = new globalThis.XMLHttpRequestOriginal();
    xhr.addEventListener("load", () => processXhrResponseError(proxy));
    xhr.addEventListener("error", () => processXhrResponseError(proxy));

    xhr[xhrMemory] = {
      tries: 0,
      headers: [],
      open: null,
      send: null,
    };
    const proxy = new Proxy(xhr, {
      get(target, prop) {
        if (prop === "send" || prop === "open") {
          return function (...args) {
            target[xhrMemory][prop] = args;
            return target[prop].apply(target, args);
          };
        }

        if (prop === "setRequestHeader") {
          return function (key, value) {
            target[xhrMemory].headers.push({ key, value });
            return target[prop].apply(target, [key, value]);
          };
        }

        if (prop === "retry") {
          return function (options) {
            return retry(xhr, options);
          };
        }

        const value = target[prop];
        return typeof value === "function" ? value.bind(target) : value;
      },

      set(target, prop, value) {
        target[prop] = value;
        return true;
      },
    });

    return proxy;
  };

  function retry(xhr, { headers = {} }) {
    const memory = xhr[xhrMemory];
    if (memory.tries >= 2) {
      throw new Error("Max of attempts reached");
    }
    memory.tries++;
    xhr.open(...memory.open);
    for (const header of memory.headers) {
      xhr.setRequestHeader(header.key, header.value);
    }
    for (const [k, v] of Object.entries(headers)) {
      xhr.setRequestHeader(k, v);
    }
    xhr.send(...memory.send);
    return xhr;
  }
}

// Utilizado pelo fetch para simular XMLHttpRequest
// PHP do ERP identifica e retorna  403 (Sessão expirou)
// caso contrário retorna um redirect
function addXMLHttpRequestHeader(opts) {
  opts = opts || {};
  opts.headers = opts.headers || {};
  opts.headers["X-Requested-With"] = "XMLHttpRequest";
  return opts;
}

function response403(text) {
  switch (text) {
    case "Sessão expirou":
    case "Sessão bloqueada":
    case "Expediente encerrado":
      Siggma.lockedSession(text);
      break;
    default:
      globalThis.Yanda.message({
        type: "error",
        title: "Controle de Acesso",
        msg: text ||
          "Oops. Seu usuário não possui acesso a este conteúdo",
      });
      break;
  }
}

function showError(detail) {
  try {
    const resp = detail ? JSON.parse(detail) : null;
    if (resp?.type) {
      Yanda.message(resp);
      return;
    }
  } catch (_e) {
    // no action
  }

  try {
    eval(detail);
  } catch (_e) {
    Yanda.message({
      type: "error",
      title: "Oh, não",
      msg: [
        "Ocorreu uma falha no processamento, ",
        "tente novamente em alguns instantes e, se o ",
        "problema persistir, entre em contato com nosso Suporte.",
      ].join("<br>"),
      detail,
    });
  }
}

function processXhrResponseError(xhr) {
  if (xhr.status == 200) {
    return;
  }

  if (
    xhr.status == 403 && xhr.getResponseHeader("x-auth-requested") && xhr.retry
  ) {
    const { type, msg, label, uuid } = JSON.parse(xhr.responseText);
    Siggma.controleAcesso({
      type,
      msg,
      label,
      sessionUuid: uuid,
      liberar: ({ sessionUuid }) =>
        xhr.retry({ headers: { "x-auth-uuid": sessionUuid } }),
    });
    return;
  }

  processHttpError(xhr.status, xhr.responseText, xhr);
}

function processHttpError(status, text, xhr = null) {
  switch (status) {
    case 400:
      Yanda.alert(true, "Oops", "Dados incorretos, tente novamente.");
      break;
    case 403:
      response403(text);
      break;
    case 404:
      Yanda.alert(true, "Oops", "Página não encontrada");
      break;
    case 413:
      Yanda.alert(
        true,
        "Oops",
        "413 - Estão sendo enviadas muitas informações ao servidor",
        false,
      );
      break;
    default:
      if (xhr?.responseType === "blob") {
        const resp = xhr?.response;
        resp.type === "application/json" &&
          resp.text().then((text) => showError(text)).catch(() => null);
        break;
      }
      showError(text || "");
      break;
  }
}
